<template>
  <div class="blockuser" v-if="seen">
    <div class="notify">
      <div v-if="loader && !saved">
        <span>
          <svg width="120px" height="120px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid" class="lds-dual-ring"
            style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
            <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
              stroke-dasharray="31.41592653589793 31.41592653589793">
              <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
                keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
            </circle>
          </svg>
        </span><br>
        <span>Please wait....</span>
      </div>
      <div v-if="!loader && saved">
        <span style="color:#0c0;">Department edited successfully</span>
      </div>
    </div>
  </div>
</template>
<script>
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      seen: false,
      loader: true,
      saved: false
    }
  },
  methods: {
    load() {
      this.saved = false
      this.seen = true
    },
    close() {
      let that = this
      this.loader = false
      this.saved = true

      setTimeout(function () {
        that.seen = false
      }, 1000)
    }
  }
}
</script>
